import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as AppSelectors from '@store/selectors/app.selectors';
import { Toast } from 'bootstrap';
import { Observable, Subject, takeUntil } from 'rxjs';
declare const bootstrap: any;

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit, AfterViewInit, OnDestroy {

  destroy$: Subject<boolean> = new Subject<boolean>();

  toastMessage$: Observable<string | null> = this.store.pipe(select(AppSelectors.selectToast));
  toastMessage: string | null = null;

  constructor(
    private store: Store<{ date: Date }>,
  ) {

  }

  @ViewChild('apptoast') toastElement!: ElementRef;

  toast: Toast | null = null;

  ngOnInit() {
    this.toastMessage$.pipe(takeUntil(this.destroy$)).subscribe((toastMessage) => {

      if (toastMessage == null) {
        return;
      }

      this.toastMessage = toastMessage;
      this.toast?.show();

    });
  }

  ngAfterViewInit(): void {
    this.toast = bootstrap.Toast.getOrCreateInstance(this.toastElement.nativeElement);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
